<template>
  <div class="bracket" key="bracket">
    <div :class="['bracket_' + type, { 'bracket_grand-final': grandFinal }]">
      <div class="bracket__rounds-container">
        <!-- <AppBtn
                    theme="grey"
                    round="3px"
                    type="button"
                    class="bracket__scroll-btn"
                    @click="scrollRoundLeft"
                >
                    <IconBase width="16" height="16" style="transform: rotate(180deg)">
                    <IconChevronSemi />
                    </IconBase>
                </AppBtn> -->
        <div class="bracket__rounds-scroll" ref="rounds">
          <div class="bracket__scroll-items">
            <div
              class="bracket__scroll-item"
              v-for="round in rounds"
              :key="round"
            >
              <div>
                <div class="font-weight-bold">Раунд {{ round + 1 }}</div>
                {{ getRoundDescription(round)
                }}<!--  - {{ getRoundFormat(round) }} -->
              </div>
            </div>
            <div class="bracket__scroll-item" v-if="grandFinal">
              <div>
                {{ getRoundDescription("grandfinal") }} -
                <!-- {{ tournament.bo_grand_final }} -->
              </div>
            </div>
          </div>
        </div>
        <!-- <AppBtn
                    theme="grey"
                    round="3px"
                    type="button"
                    class="bracket__scroll-btn"
                    @click="scrollRoundRight"
                >
                    <IconBase width="16" height="16"><IconChevronSemi /></IconBase>
                </AppBtn> -->
      </div>
      <div
        class="bracket__grid"
        ref="grids"
        @scroll="onGridScroll($event)"
        v-dragscroll
      >
        <BracketsGrid
          :grid-data="bracket"
          :rounds="rounds"
          :type="type"
          :grand-final="grandFinal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import rangeRight from "lodash/rangeRight";
import { dragscroll } from "vue-dragscroll";
import BracketsGrid from "./BracketsGrid.vue";
window.rangeRight = rangeRight;
export default {
  components: {
    BracketsGrid
  },
  directives: {
    dragscroll
  },

  props: {
    bracket: { required: true },
    tournament: { required: false },
    type: { type: String, default: "single" },
    grandFinal: { required: false }
  },

  computed: {
    isSingle() {
      return this.type === "single";
    },

    roundDescriptions() {
      return {
        grandfinal: "Гранд финал",
        // "1": "Финал",
        // "2": "Полуфинал",
        // "3": "Четвертьфинал",
        "0": "Финал",
        "1": "Полуфинал",
        "2": "Четвертьфинал"
      };
    }
  },

  methods: {
    getRoundDescription(round) {
      return this.roundDescriptions[round] || "1/" + Math.pow(2, round);
    },

    onGridScroll(e) {
      const left = e.currentTarget.scrollLeft;
      this.$refs.rounds.scrollLeft = left;
    },

    getRoundWidth() {
      const roundItem = this.$el.querySelector(".bracket__scroll-item");
      return roundItem.offsetWidth;
    },

    scrollRoundLeft() {
      const grids = this.$refs.grids;
      const width = this.getRoundWidth();
      const times = Math.floor(grids.scrollLeft / width);
      const timesWidth = width * times;
      if (grids.scrollLeft - timesWidth > 50) {
        grids.scrollLeft = width * times;
      } else {
        grids.scrollLeft = width * (times - 1);
      }
    },

    scrollRoundRight() {
      const grids = this.$refs.grids;
      const width = this.getRoundWidth();
      const times = Math.ceil(grids.scrollLeft / width);
      const timesWidth = width * times;
      if (timesWidth - grids.scrollLeft < 50) {
        grids.scrollLeft = width * (times + 1);
      } else {
        grids.scrollLeft = width * times;
      }
    },

    getRoundFormat(round) {
      if (round == 0) return this.tournament.bo_final;
      if (round == 1) return this.tournament.bo_semifinal;
      return this.tournament.bo_type;
    }
  },

  created() {
    if (!Object.keys(this.bracket).length) return;
    let stage = Math.max.apply(
      Math,
      Object.keys(this.bracket).map(n => Number(n))
    );
    this.rounds = rangeRight(0, Math.log2(stage) + 1);

    // if (!this.bracket.length) return;
    // this.rounds = rangeRight(0, Math.log2(this.bracket[0].stage) + 1);
  }
};
</script>

<style lang="scss">
.bracket {
  padding: 20px 15px 20px 20px;
  background: #000a25;
  border-radius: 6px;

  &_single {
    border-radius: 6px;
    overflow: hidden;
  }

  &__header {
    color: grey;
    background-color: lime;
  }

  &__grid {
    max-height: 680px;
    overflow: auto;
    cursor: grab;

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: rgba(#05081b, 0.5);
      border-radius: 100px;
    }

    &::-webkit-scrollbar-thumb {
      background: #1480b2;
      border-radius: 100px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #5bcdff;
    }
  }

  &__rounds-container {
    height: 70px;
    position: relative;
    margin-right: 5px;
    border-top-right-radius: 6px;
    overflow: hidden;
  }

  &__rounds-scroll {
    height: 100%;
    overflow: hidden;
  }

  &__scroll-items {
    display: inline-flex;
    min-width: 100%;
    height: 100%;
    align-items: center;
    color: rgba(#fff, 0.5);
  }

  &__scroll-item {
    padding-left: 50px;
    line-height: 1.3;
    border-bottom: 1px solid rgba(#fff, 0.1);

    height: 100%;
    display: flex;
    align-items: center;
    /* &:not(:last-child) {
            margin-right: 1px;
        } */
    &:last-child {
      width: 200px;
      padding-right: 5px;
      border-top-right-radius: 6px;
      overflow: hidden;
    }

    position: relative;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    &:nth-child(odd):before {
      background: linear-gradient(
        180deg,
        #7cd7ff 0%,
        rgba(124, 215, 255, 0.5) 100%
      );
      background-size: 100% 100vh;
      opacity: 0.07;
    }

    &:nth-child(even):before {
      background: linear-gradient(
        180deg,
        #7cd7ff 0%,
        rgba(124, 215, 255, 0.5) 100%
      );
      background-size: 100% 100vh;
      opacity: 0.1;
    }
  }

  &__scroll-btn {
    width: 30px;
    height: 36px;
    color: #646c75;
    background-color: #3a4047;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    &:first-child {
      left: 10px;
    }
    &:last-child {
      right: 10px;
    }
  }

  &_single & {
    &__scroll-item {
      padding-left: 0;
      width: 200px;
      text-align: center;
      justify-content: center;
    }
  }

  &_double & {
    &__scroll-item {
      width: 540px;
    }
  }
}
</style>
